export default {
    state: {
        userIdCommented: 0,
    },
    mutations: {
        ADD_USER_ID_COMMENTED(state, item) {
            state.userIdCommented = item
        },
    },
    actions: {
        addUserIdCommented(context, item) {
            context.commit('ADD_USER_ID_COMMENTED', item)
        },
    },
}
